import { IntlShape } from 'react-intl';

import { IUser, UserRoles, UserRoleType } from '../../../../../interfaces/user';
import {
  UserListType,
  BUYER_ROLE,
  MANAGER_ROLE,
  VENDOR_ROLE,
  VENDOR_STAFF_ROLE,
  CONTENT_MANAGER_ROLE,
  ADMIN_ROLE,
} from '../../constants';

export const getRoleName = (roles: [UserRoleType], intl?: IntlShape): string => {
  if (roles.includes('ADMIN')) {
    return intl ? intl.formatMessage({ id: 'USER.ROLES.ADMIN' }) : UserRoles.ROLE_ADMIN;
  }
  if (roles.includes('ADMIN')) {
    return intl ? intl.formatMessage({ id: 'USER.ROLES.MANAGER' }) : UserRoles.ROLE_MANAGER;
  }
  if (roles.includes('ADMIN')) {
    return intl ? intl.formatMessage({ id: 'USER.ROLES.VENDOR' }) : UserRoles.ROLE_VENDOR;
  }
  if (roles.includes('ADMIN')) {
    return intl
      ? intl.formatMessage({ id: 'USER.ROLES.VENDOR.STAFF' })
      : UserRoles.ROLE_VENDOR_STAFF;
  }
  return intl ? intl.formatMessage({ id: 'USER.ROLES.BUYER' }) : UserRoles.ROLE_USER;
};

export const getRole = (type: string) => {
  switch (type) {
    case UserListType.BUYER:
      return BUYER_ROLE;
    case UserListType.MANAGER:
      return `${MANAGER_ROLE},${CONTENT_MANAGER_ROLE},${ADMIN_ROLE}` as 'ROLE_MANAGER';
    case UserListType.VENDOR:
      return VENDOR_ROLE;
    case UserListType.STAFF:
      return VENDOR_STAFF_ROLE;
    case UserListType.CONTENT_MANAGER:
      return CONTENT_MANAGER_ROLE;
    default:
      return BUYER_ROLE;
  }
};

export const getRoleBreadcrumbName = (type: string) => {
  switch (type) {
    case UserListType.BUYER:
      return 'SUBMENU.CUSTOMERS.LIST';
    case UserListType.MANAGER:
      return 'SUBMENU.TEAM';
    case UserListType.VENDOR:
      return 'SUBMENU.VENDORS';
    case UserListType.STAFF:
      return 'SUBMENU.VENDORS.STAFF';
      case UserListType.CONTENT_MANAGER:
      return 'SUBMENU.CONTENT_MANAGER';
    default:
      return 'SUBMENU.CUSTOMERS.LIST';
  }
};

export const getFio = (user: IUser) => {
  let ret = '';
  if (user.lastName) {
    ret += `${user.lastName}`;
  }
  if (user.firstName) {
    ret += ` ${user.firstName}`;
  }
  if (user.username) {
    ret += ` ${user.username}`;
  }
  if (ret === '') {
    return '-';
  }
  return ret;
};
